import {
  drawBlobArcherProcedural,
  drawBlobClericProcedural,
  drawBlobCrystalKnightProcedural,
  drawBlobCrystalWizardProcedural,
  drawBlobKnightProcedural,
  drawBlobMageProcedural,
  drawBlobPaladinProcedural,
  drawBlobRogueProcedural,
  drawBlobSlimeProcedural,
  drawBlobWarlockProcedural,
} from './blobMobs';
import {
  drawAmberClusterProcedural,
  drawAnalystOrbProcedural,
  drawAquaCoreProcedural,
  drawArcLensProcedural,
  drawCoralBloomProcedural,
  drawCrimsonSunProcedural,
  drawDuskSeraphProcedural,
  drawEmberClusterProcedural,
  drawFrostShardProcedural,
  drawGlacierSigilProcedural,
  drawIronMawProcedural,
  drawMagmaVentProcedural,
  drawPlagueWispProcedural,
  drawPrismHaloProcedural,
  drawRuneGyreProcedural,
  drawShadowKnotProcedural,
  drawSolarFloretProcedural,
  drawToxicCometProcedural,
  drawVerdantNodeProcedural,
  drawVioletRingProcedural,
  drawVoidEyeProcedural,
} from './elementalMobs';
import {
  drawSphereArcherProcedural,
  drawSphereBruteProcedural,
  drawSphereKnightProcedural,
  drawSphereMageProcedural,
} from './sphereMobs';

export type ProceduralMobDrawFn = (
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  size: number,
  alpha: number,
  rotation?: number
) => void;

const PROCEDURAL_MOB_DRAWERS: Record<string, ProceduralMobDrawFn> = {
  triangle: drawBlobMageProcedural,
  zombie: drawBlobSlimeProcedural,
  warrior: drawBlobKnightProcedural,
  ranger: drawBlobArcherProcedural,
  cleric: drawBlobClericProcedural,
  rogue: drawBlobRogueProcedural,
  paladin: drawBlobPaladinProcedural,
  warlock: drawBlobWarlockProcedural,
  crystal_knight: drawBlobCrystalKnightProcedural,
  crystal_wizard: drawBlobCrystalWizardProcedural,
  analyst_orb: drawAnalystOrbProcedural,
  amber_cluster: drawAmberClusterProcedural,
  crimson_sun: drawCrimsonSunProcedural,
  violet_ring: drawVioletRingProcedural,
  aqua_core: drawAquaCoreProcedural,
  verdant_node: drawVerdantNodeProcedural,
  ember_cluster: drawEmberClusterProcedural,
  prism_halo: drawPrismHaloProcedural,
  void_eye: drawVoidEyeProcedural,
  solar_floret: drawSolarFloretProcedural,
  rune_gyre: drawRuneGyreProcedural,
  glacier_sigil: drawGlacierSigilProcedural,
  toxic_comet: drawToxicCometProcedural,
  iron_maw: drawIronMawProcedural,
  dusk_seraph: drawDuskSeraphProcedural,
  frost_shard: drawFrostShardProcedural,
  magma_vent: drawMagmaVentProcedural,
  plague_wisp: drawPlagueWispProcedural,
  coral_bloom: drawCoralBloomProcedural,
  shadow_knot: drawShadowKnotProcedural,
  arc_lens: drawArcLensProcedural,
  sphere_archer: drawSphereArcherProcedural,
  sphere_mage: drawSphereMageProcedural,
  sphere_knight: drawSphereKnightProcedural,
  sphere_brute: drawSphereBruteProcedural,
};

export const PROCEDURAL_ENTITY_TYPES = Object.keys(PROCEDURAL_MOB_DRAWERS);

export function isProceduralMobType(entityType: string): boolean {
  return entityType in PROCEDURAL_MOB_DRAWERS;
}

export function drawProceduralMobType(
  entityType: string,
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  spriteSize: number,
  rotation: number
): void {
  const draw = PROCEDURAL_MOB_DRAWERS[entityType];
  if (!draw) {
    return;
  }
  draw(ctx, centerX, centerY, spriteSize, 1, rotation);
}
